import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class ShallowSeaSmallPiratesSalvageableTileEntity extends TileEntity {
	public static readonly frameName = FrameName.SHALLOW_SEA_SMALL_PIRATES;
}

export default ShallowSeaSmallPiratesSalvageableTileEntity;
